export default {
      id: "color_person_wgs-usage",
      viewBox: "0 0 61 71",
      url: __webpack_public_path__ + "sprite.svg#color_person_wgs",
      toString: function () {
        return this.url;
      }
    }